import { Skeleton } from 'atp-react-ui';

import { Container, PageHead } from '@/_components';

export default function Loading() {
  return (
    <>
      <Container>
        <PageHead className="flex-col items-start">
          <section className="mt-2 flex items-center">
            <Skeleton className="mr-4 size-8" />
            <Skeleton className="h-8 w-64" />
          </section>

          <div className="flex flex-col gap-y-2 pt-3 text-sm text-accent-light/80 sm:mt-0 sm:flex-row sm:flex-wrap sm:space-x-6">
            <div className="flex items-center">
              <Skeleton className="h-[1.125rem] w-64" />
            </div>
          </div>
        </PageHead>
      </Container>

      <Container className="mt-7">
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {Array.from({ length: 8 }).map((_, index) => (
            <div key={index} className="course-card divide-outline overflow-hidden">
              <article className="course-card-article">
                <header className="course-card-article-header mt-6 border-outline/30">
                  <Skeleton className="h-40 w-full" />
                </header>

                <section className="course-card-article-body">
                  <div className="px-4 py-2">
                    <Skeleton className="h-6 w-3/4" />
                  </div>
                </section>
              </article>
            </div>
          ))}
        </div>
      </Container>
    </>
  );
}
